// @ts-check

/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-access-state-in-setstate */
import React, { useState, createRef } from 'react';
import PropTypes from 'prop-types';
import { Table, Form, Button, Drawer, Col, Row, Alert } from 'antd';
import { EITC_ALPHA_NUMERIC, EITC_NUMERIC } from 'global_config/constant-global';
import DynamicInput from '../dynamic_input';
import LineChart from './line_chart';
import { filter, orderBy } from 'lodash';
import Message from 'shared_components/message';
import '../result_table.css';

function ChartDrawer(props) {
	const {
		formatedResults,
		visible,
		drawerTitle,
		toggleDrawer,
		resultStatus,
		catchChanges,
		currentFieldValues,
		patientHistory,
		getFormValues,
		// onChangeResult,
	} = props;

	const [chartData, setChartData] = useState([]);
	const [timer, setTimer] = useState(null);
	const [drawerFormIsTouched, setDrawerFormIsTouched] = useState(false);
	const chartColumns = [
		{
			title: 'EXAM',
			dataIndex: 'examItemName',
			width: '30%',
			render: (text, record) => <div style={record.isChild && { marginLeft: 30 }}>{text}</div>,
		},
		{
			title: 'RESULT',
			dataIndex: 'releasedResult',
			width: '30%',
			render: (text, record) => {
				if (record.releasedResult !== undefined) {
					return createFormInput({
						...record,
						fieldName: `${record.sampleSpecimenID}-${record.examItemID}`,
					});
				}

				return null;
			},
		},
		{
			title: 'UNIT CODE',
			width: '20%',
			align: 'center',
			render: (text, record) => {
				if (record.unitOfMesureBase && record.examItemUnitCode)
					return `${record.unitOfMesureBase} - ${record.examItemUnitCode}`;

				return '';
			},
		},
	];
	const formRef = createRef();

	const prepareDataset = (record, fieldValue) => {
		//initialize variables for data prep
		const dateTest = new Date(); //generate projected date
		const time = dateTest.toLocaleTimeString('en-US').toLocaleLowerCase(); // and time
		const targetDateTime = dateTest.toLocaleDateString() + ' ' + time; // stitch them together
		const {
			examItemID,
			examItemName,
			examItemUnitCode,
			rangeLow,
			rangeHigh,
			unitOfMesureBase,
		} = record;
		let [targetRangeHigh, targetRangeLow, targetUnits, hasPreviousResults] = [
			rangeHigh,
			rangeLow,
			unitOfMesureBase,
			false,
		];
		// inputIsTouched = true;
		const data = orderBy(
			filter(patientHistory, { examCode: String(examItemID) }),
			['approveDate'],
			['asc'],
		);
		try {
			if (data.length > 0) {
				// previous records go here
				const { rangeLow, rangeHigh } = data[data.length - 1]; //get sample data from existing data to plot range low and high
				//set your targets
				[targetRangeLow, targetRangeHigh, targetUnits, hasPreviousResults] = [
					rangeLow,
					rangeHigh,
					examItemUnitCode,
					true,
				];
			}

			if (fieldValue.length > 0) {
				data.push({
					approveDate: targetDateTime,
					examCode: examItemID,
					examItemName: examItemName,
					rangeHigh: targetRangeHigh,
					rangeLow: targetRangeLow,
					requestDate: targetDateTime,
					releasedResult: fieldValue,
					unitOfMeasureBase: targetUnits,
				});
			}

			data.forEach(x => {
				x.hasPreviousResults = hasPreviousResults;
				x.inputIsTouched = true;
			});

			setChartData(data);
		} catch (error) {
			Message.error(error);

			console.log('error', error);
		}
	};

	const createFormInput = record => {
		const initialValue = currentFieldValues[record.fieldName];

		return (
			<Form.Item name={record.fieldName} initialValue={initialValue}>
				<DynamicInput
					hideElements={true}
					type={record.examItemTypeCode}
					isLock={record.examRequestItemLock === 1 || resultStatus === 'Approved'}
					itemOptions={record.examItemOptions}
					maxLength={record.maxLength}
					onChange={x => {
						handleChangeInput(x, record);
					}}
					onFocus={x => {
						handleChangeInput(x, record);
					}}
				/>
			</Form.Item>
		);
	};

	const handleChangeInput = (event, record) => {
		// getFormValues();
		let targetValue = 0;

		if ([EITC_ALPHA_NUMERIC, EITC_NUMERIC].includes(record.examItemTypeCode)) {
			event.persist();
			targetValue = event.target.value;
		}

		clearTimeout(timer);
		const newTimer = setTimeout(() => {
			prepareDataset(record, targetValue);
		}, 1000); //delay by 1 second
		setTimer(newTimer);

		if (targetValue > 0) {
			setDrawerFormIsTouched(true);
		}
	};


	const handleSubmit = (formValues) => {
		catchChanges(formValues);
		closeChartDrawer();
	};

	const submitButtonProps = {
		shape: 'round',
		type: 'primary',
		htmlType: 'submit',
		style: { margin: 10, width: 120 },
		disabled: drawerFormIsTouched ? false : true,
	};

	const alertDescription = (
		<div className="alert-description">
			Welcome to the Charting Drawer. After you input your values, you may press{' '}
			<code>Shift + Enter</code> keys or click the ok button to pass these values to the previous
			page.
		</div>
	);

	const closeChartDrawer = () =>{
		setChartData([]);
		setDrawerFormIsTouched(false);
		toggleDrawer();
	}

	return (
		
		<Drawer
			title={<strong>{drawerTitle}</strong>}
			visible={visible}
			onClose={closeChartDrawer}
			width={'95%'}
			maskClosable={true}
			closable={true}
			destroyOnClose
		>
			<Form ref={formRef} onFinish={handleSubmit}>
				<Row gutter={[24, 24]} justify={'center'} align={'middle'}>
					<Col span={9}>
						<Table
							columns={chartColumns}
							dataSource={formatedResults}
							rowKey={item => item.examItemID}
							scroll={{ x: 30, y: 400 }}
							size={'small'}
							pagination={false}
						/>
					</Col>
					<Col span={15}>
						<LineChart dataSet={chartData} />
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<Alert message="Tip" type="info" description={alertDescription} showIcon />
					</Col>
				</Row>
				<Row justify={'end'} align={'top'}>
					<Form.Item>
						<Button shape="round" onClick={closeChartDrawer} style={{ margin: 10, width: 120 }}>
							CLOSE
						</Button>
					</Form.Item>
					<Form.Item>
						<Button {...submitButtonProps}>OK</Button>
					</Form.Item>
				</Row>
			</Form>
		</Drawer>
	);
}

ChartDrawer.propTypes = {
	formatedResults: PropTypes.array.isRequired,
	visible: PropTypes.bool.isRequired,
	toggleDrawer: PropTypes.func.isRequired,
	drawerTitle: PropTypes.string.isRequired,
	resultStatus: PropTypes.string.isRequired,
	catchChanges: PropTypes.func.isRequired,
	currentFieldValues: PropTypes.object.isRequired,
	patientHistory: PropTypes.array.isRequired,
};

export default ChartDrawer;
